import { exportToExcel } from "../../utils/ExportUtils";
import dayjs from "dayjs";

const ExportHandler = ({ searchResults, selectedRowKeys }) => {
  const handleExport = () => {
    console.log("Exporting search results...");

    let rowsToExport;


    if (selectedRowKeys.length > 0) {
      // Handle selected rows (selectedRowKeys is a non-empty array)
      rowsToExport = searchResults.filter((row) =>
        selectedRowKeys.includes(row.uid)
      );
    } else {
      // Handle all rows (selectedRowKeys is an empty array)
      rowsToExport = searchResults; // All rows
    }

    if (rowsToExport.length === 0) {
      console.warn("No rows selected for export.");
    }

    const formattedData = rowsToExport.map((row) => ({
      ...row,
      name: row.firstName ? `${row.firstName} ${row.lastName}` : "",
      onBoardingDate: row.onBoardingDate ? row.onBoardingDate : "N/A",
    }));

    console.log(formattedData);

    const mainHeader = "Employee Details";
    const columnHeaders = [
      { key: "uid", label: "UID", width: 10 },
      { key: "name", label: "EMPLOYEE NAME", width: 30 },
      { key: "onBoardingDate", label: "ONBOARDING DATE", width: 20 },
      { key: "baseLocation", label: "LOCATION", width: 20 },
      { key: "status", label: "STATUS", width: 15 },
    ];

    const now = new Date();
    const formattedDateTime = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
      now.getHours()
    ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    const fileName = `Export_${formattedDateTime}.xlsx`;
    const sheetName = "Employees";

    exportToExcel(
      formattedData,
      fileName,
      sheetName,
      mainHeader,
      columnHeaders
    );
  };

  return handleExport;
};

export default ExportHandler;